import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import { siteMeta } from '@/mocks/homeData';

export default function BookmarkCta() {
  const { copiedId, copy } = useCopyToClipboard();
  const isCopied = copiedId === 'cta-site';

  return (
    <section id="bookmark" className="scroll-mt-24 w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="relative rounded-lg overflow-hidden min-h-[300px] md:min-h-[360px] flex items-center">
          <div className="absolute inset-0 w-full h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20warm%20panoramic%20artwork%20of%20layered%20paper%20waves%20in%20terracotta%20sand%20and%20olive%20tones%2C%20soft%20paper%20grain%20texture%2C%20wide%20editorial%20composition%2C%20calm%20reassuring%20mood%2C%20deep%20warm%20shadow%20on%20the%20left%20side%2C%20no%20text&width=1600&height=520&seq=hlzl-cta-banner&orientation=landscape"
              alt="收藏本页，随时获取新网址"
              title="黑料地址 收藏本页 永久链接"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/40 to-foreground-950/10" aria-hidden="true" />

          <div className="relative z-10 w-full px-6 md:px-12 py-10 md:py-14 max-w-2xl">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/90 text-foreground-900 text-xs font-label whitespace-nowrap">
              <i className="ri-bookmark-3-line" aria-hidden="true" />
              一步收藏，永久有效
            </span>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold leading-snug text-background-50">
              现在就收藏本页，之后不用再找
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-100">
              记住「{siteMeta.name}」这个名字，或直接把当前地址存进书签。地址有变动时，回到这里就能拿到最新入口，永远有路可走。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <button
                type="button"
                onClick={() => copy(siteMeta.shareUrl, 'cta-site')}
                className={`inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-label whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  isCopied
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-50 text-foreground-950 hover:bg-background-100'
                }`}
              >
                <i className={isCopied ? 'ri-check-line' : 'ri-file-copy-line'} aria-hidden="true" />
                {isCopied ? '本站地址已复制' : '复制本站地址'}
              </button>
              <a
                href="#entrances"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-50/70 text-background-50 text-sm font-label hover:bg-background-50/10 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-link" aria-hidden="true" />
                查看最新入口
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}